import { useMemo } from "react"
import ReactSelect from "react-select"
import useT from "utils/hooks/useT"

export default function LocationPicker({ required, disabled, value, onChange, menuPlacement }) {
  const { t } = useT("common")
  const locationPickerOptions = useMemo(
    () => [
      { label: <>{t("onsite")}</>, value: true },
      { label: <>{t("anywhere")}</>, value: false },
    ],
    [t]
  )
  const locationStateValue = locationPickerOptions.find((item) => item.value === value)
  if (required && !locationStateValue) {
    throw new Error("LocationPicker received an invalid value")
  }
  return (
    <ReactSelect
      className="TaskStatePicker"
      classNamePrefix="TaskStatePicker"
      placeholder={t("selectLocation")}
      isClearable={false}
      isDisabled={disabled}
      isSearchable={false}
      options={locationPickerOptions}
      onChange={({ value }) => onChange(value)}
      value={locationStateValue}
      menuPosition="absolute"
      menuPlacement={menuPlacement}
    />
  )
}
